import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  appRequestSelector,
  prequalDataSelector,
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";
import ProgressiveLogo from "../../../../../assets/img/progressive-logo.png";
import { addThousandsSeparator } from "../../../../../utils/helpers";
import DueTodayBreakdown from "../DueTodayBreakdown";
import "./styles.scss";

class PrequalApprovedScreen extends Component {
  handleSignLease = () => {
    const { appRequest, prequalData, selectOffer } = this.props;

    selectOffer({
      selectedOffer: {
        app_id: prequalData.app_id,
        provider: 'progressive',
        specific_provider_name: 'progressive',
        banking_data: false,
        offer_id: prequalData.application_id,
        approval_amount: prequalData.approval_amount,
        contractUrl: prequalData.contract_url,
        cart_total: prequalData.cart_total,
      },
      body: {
        items: appRequest.items,
        orderId: appRequest.orderId,
        shipping: appRequest.shipping,
      },
    });
  };

  render() {
    const { loading, prequalData } = this.props;

    if (!prequalData) return null;

    const approvalAmount = `$${addThousandsSeparator(prequalData.approval_amount)}`;
    const initialPayment = prequalData.initial_payment_total
      ? `$${addThousandsSeparator(prequalData.initial_payment_total)}`
      : null;
    const periodicPayment = prequalData.periodic_payment_total
      ? `$${addThousandsSeparator(prequalData.periodic_payment_total)}`
      : null;
    const installationFee = parseFloat(prequalData.installation_fee) || 0;

    return (
      <div className="expanded-block-component bank-data-form-container prequal-approved-screen">
        <div className="bank-data-form-header">
          <img src={ProgressiveLogo} alt="Progressive Logo" />
          <h1>Congrats, You're Approved!</h1>
          <p>
            {`You've been approved to lease items up to ${approvalAmount} in cash price with Progressive Leasing.`}
          </p>

          <div className="approval-amount">
            <p className="font-bold">
              Approval Amount <span className="font-bold">{approvalAmount}</span>
            </p>
          </div>

          {(initialPayment || periodicPayment) && (
            <div className="payment-details">
              {initialPayment && (
                <p>
                  Initial Payment <span>{initialPayment}</span>
                </p>
              )}
              {periodicPayment && (
                <p>
                  Periodic Payment <span>{periodicPayment}</span>
                </p>
              )}
            </div>
          )}

          {installationFee > 0 && (
            <DueTodayBreakdown
              initialPayment={prequalData.initial_payment_total || 1}
              installationFee={installationFee}
            />
          )}

          <p className="font-italic">
            *Applicable taxes will be added to all payments and collected by
            Progressive Leasing.
          </p>
        </div>

        <div className="footer">
          <BlueBtn loading={loading} onClick={this.handleSignLease}>
            Sign Lease & Place Order
          </BlueBtn>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  prequalData: prequalDataSelector()(state),
  appRequest: appRequestSelector()(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

PrequalApprovedScreen = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrequalApprovedScreen);

export default PrequalApprovedScreen;